<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="لأننا-كائنات-محبة">
<h1><span dir="rtl">لأنَّنا كائناتٌ مُحِبَّة</span></h1>
<p style="text-indent:01em;"><span dir="rtl">في المحبّة تتَّضحُ معاني الحياة المُبهمة، معانٍ نجتهدُ كلَّ يومٍ لاكتشاف أعماقها، لتجسد حقيقة إنسانيَّتنا بعطاءاتٍ تُخرِجُ سموَّ الرُّوح، شعوراً يجعلُنا نرغبُ الارتقاءَ والتَّحليق.</span></p>
<p><span dir="rtl">كلٌّ منَّا مُحبٌّ ومَحبوب، وكلٌّ منَّا يروي قصَّتَه بطريقةٍ تختلفُ فيها مستويات العذوبة، والصّدق، والعاطفة.</span></p>
<p><span dir="rtl">بعضُ الحبِّ يروي، وبعضُه يصيبُنا بظمأَ مُزمنٍ، نُعاني خلالَ بحثنا عنه من أمواجِ الحياة العاتية، وفي النِّهاية تصقلُ داخلنا، وتزيد من لمعان جوهرنا، ونتباهى بحبٍّ يحيا ويتجاوزُ محدوديَّة أفكارنا.</span></p>
<p><span dir="rtl">يحوِّلُ الحبُّ المحبّين أيقوناتِ همسٍ واستمرار، وحكايا تتناقلُها الأجيالُ، يطلقون فيها أشعَّة نور تخترقُ ظلامَ الكراهيةِ والبغضاء، وتُنهي شعوذةَ القيد والانطفاء، فتتحرَّرُ الأرواحُ، وتتخلَّصُ من كلِّ ما شابها من صدأ وسواد، تنفضُ غبارَ الابتعاد عن جوهر الإنسانيَّة لتصلَ أخيراً لشاطئ الأمان، لشاطئٍ ينعمُ فيه جميعُ من يصله بطعمِ الوجود الحقيقي، وينال فيه لقبَ عاشق.</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?c52138e6